'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    function createButtons(heading, buttonClass) {
        context.find(heading).each(function () {
            $(this).replaceWith('<button class="' + buttonClass + '">' + $(this).text() + '</button>');
        });
    }

    function accordian(heading) {
        heading.closest('.report-as-email__content').addClass('closed');

        heading.on('click', function (e) {
            e.preventDefault();
            heading.closest('.report-as-email__content').addClass('closed');
            context.find('input[type="checkbox"]').removeAttr('checked');
            context.find('.field-hint').addClass('closed');
            $(this).closest('.report-as-email__content').toggleClass('closed');
        });
    }

    function createFormLink(element) {
        element.append('<button data-binding="close" class="contact-us__close">&#215;</button><p><a data-binding="scroll-to-form" href="#contact-details">Doesn\'t answer your question? Contact us if you need any further help.</a></p>');
    }

    function expandFormOnerrorReload() {
        context.find('.report-as-email__option input[type="checkbox"]:checked').each(function () {
            $(this).closest('.report-as-email__content').removeClass('closed');
            $(this).parent().parent().next().removeClass('closed').find('[data-binding="scroll-to-form"]').click();
        });
    }

    function init() {
        var fieldHint = context.find('.field-hint'),
            fieldCheckbox = context.find('.report-as-email__option'),
            sectionHeadingWrapClass = 'report-as-email__heading-wrapper',
            sectionHeadingWrap = context.find('.' + sectionHeadingWrapClass),
            formDivs = context.find('.module-wrapper .content-block').slice(-4);

        context.find('[data-binding="form-content"]').addClass('hidden');
        formDivs.addClass('hidden');
        context.find('.button.donation-form').addClass('hidden');
        context.find('[data-binding="report-as-email-recaptcha"]').addClass('hidden');

        createButtons(sectionHeadingWrap, sectionHeadingWrapClass);

        createFormLink(fieldHint);

        accordian(context.find('.' + sectionHeadingWrapClass));

        fieldHint.addClass('closed');

        fieldCheckbox.find('input[type="checkbox"]').on('change', function () {
            if ($(this).is(':checked')) {
                $(this).parent().parent().next().removeClass('closed');
            } else {
                $(this).parent().parent().next().addClass('closed');
            }
        });

        context.find('[data-binding="close"]').on('click', function (e) {
            e.preventDefault();
            $(this).parent().prev().find('input[type="checkbox"]').attr('checked', false);
            $(this).parent().addClass('closed');
        });

        context.find('[data-binding="scroll-to-form"]').on('click', function () {
            var title = $(this).parents('.field-hint').prev('.field-group').find('input[type="checkbox"]').val();
            formDivs.removeClass('hidden').addClass('formitem');
            context.find('[data-binding="form-content"]').removeClass('hidden');
            context.find('.button.donation-form').removeClass('hidden');
            context.find('[data-binding="report-as-email-recaptcha"]').removeClass('hidden');
            formDivs.find('.report-as-email__content').removeClass('closed');
            context.find('.module-wrapper .content-block:last-child').prev().prev().prev().find('.report-as-email__question-textanswer').val(title);

            if ($(this).parents('.field-hint').prev('.field-group').find('input[type="checkbox"]').attr('data-binding') === 'image-upload') {
                context.find('[data-binding="file-image-upload"]').parent().removeClass('hidden');
            } else {
                context.find('[data-binding="file-image-upload"]').parent().addClass('hidden');
            }
        });

        expandFormOnerrorReload();
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/contact-us.js
// module id = 488
// module chunks = 0